module.exports = __webpack_public_path__ + "static/leavinghk-0c674d3d865e2abc14b3067a843c968e.jpg";